import {GET_SESSION, GET_INVITATIONS_BY_REFERENCE} from './queries'
import {isClient} from '@cred/shared/utils'
import config from 'config'
import rollbar from '@cred/shared/rollbar'

const COOKIE_OPTIONS = {path: '/'},

  getCookiePrefix = () => `CognitoIdentityServiceProvider.${config.cognitoClientID}`,

  getLastUser = cookies => cookies.get(`${getCookiePrefix()}.LastAuthUser`),

  getSession = async(client, cookies) => {
    if (!getLastUser(cookies)) {
      return {}
    }

    const expire = cookies.get('auth_expires', COOKIE_OPTIONS) || 0,
      fiveMinutes = 300

    if ((expire - fiveMinutes) * 1000 < Date.now()) {
      await client.query({query: GET_SESSION})
    }

    return {
      authExpires: cookies.get('auth_expires', COOKIE_OPTIONS),
      userId: cookies.get('user_id', COOKIE_OPTIONS),
      email: decodeURIComponent(cookies.get('email', COOKIE_OPTIONS))
    }
  },

  isAuthenticated = async(client, cookies) => {
    try {
      const user = await getSession(client, cookies)

      return !!user.email
    } catch {
      return false
    }
  },

  getCampaign = cookies => {
    const options = {doNotParse: true}

    return {
      utmCampaign: cookies.get('utm_campaign', options) || 'default',
      utmMedium: cookies.get('utm_medium', options) || 'default',
      utmSource: cookies.get('utm_source', options) || 'default',
      utmContent: cookies.get('utm_content', options) || 'default',
      utmReferrer: cookies.get('utm_referrer', options) || null,
      blogLanding: cookies.get('blog_landing', options) || 'default',
      blogLastpage: cookies.get('blog_lastpage', options) || 'default',
      referralCode: cookies.get('referral_link', options) || null,
      partner: cookies.get('partner', options) || null,
      gclid: cookies.get('gclid', options) || null,
      msclkid: cookies.get('msclkid', options) || null,
      kclickid: cookies.get('kclickid', options) || null,
      kclickDate: cookies.get('kclick_date', options) || null,
      userAgent: isClient() ? navigator.userAgent : null
    }
  },

  getInvitation = async (client, cookies, args) => {
    const {invitationReference, inviteeEmail} = args

    try {
      const {data: {myInvitationsByReference}} = await client.query({
        query: GET_INVITATIONS_BY_REFERENCE,
        variables: {
          input: {
            reference: invitationReference,
            inviteeEmail,
            workflowStatus: [
              'INVITED'
            ],
            sortOrder: 'desc'
          }
        },

        /**
         * TODO: Remove that code once
         * https://credible.atlassian.net/browse/REFI-535 is completed.
         * Our Invitation API requires authorization header in request.
         * This context should be removed once Invitation API supports new credible-node-oidc package.
         */
        context: {headers: {Authorization: `Bearer ${getAuthIdToken(cookies)}`}}
      })

      return myInvitationsByReference.find(ref => ref.inviteeEmail === inviteeEmail)
    } catch (error) {
      rollbar.error('[invitation] Invitation NOT found', error)
      throw error
    }
  },

  // TODO: Remove this method
  getCurrentUser = cookies => cookies,

  // TODO: Remove this method
  getAuthIdToken = cookies => cookies.get(`${getCookiePrefix()}.${encodeURIComponent(decodeURIComponent(getLastUser(cookies)))
    .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
    .replace(/[\(\)]/g, escape)
  }.idToken`) || ''

export {
  getSession,
  isAuthenticated,
  getCampaign,
  getCurrentUser,
  getAuthIdToken,
  getInvitation
}
